import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e887b93e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 成本优化解决方案 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('通过成本可视化实现深入成本洞察，并提供精细化的算力治理，' +
          '在维持业务稳定性的前提下，帮助企业降低IT成本高达50%。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" <a-space :size=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'\">\n        <a-button type=\"link\" class=\"button_n_1\"\n                  @click=\"$RQ.GoGSS()\">\n          免费试用\n        </a-button>\n      </a-space> ")
    ])
  ]))
}